"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.guardTypeBeet = exports.GuardType = void 0;
const beet = __importStar(require("@metaplex-foundation/beet"));
var GuardType;
(function (GuardType) {
    GuardType[GuardType["BotTax"] = 0] = "BotTax";
    GuardType[GuardType["SolPayment"] = 1] = "SolPayment";
    GuardType[GuardType["TokenPayment"] = 2] = "TokenPayment";
    GuardType[GuardType["StartDate"] = 3] = "StartDate";
    GuardType[GuardType["ThirdPartySigner"] = 4] = "ThirdPartySigner";
    GuardType[GuardType["TokenGate"] = 5] = "TokenGate";
    GuardType[GuardType["Gatekeeper"] = 6] = "Gatekeeper";
    GuardType[GuardType["EndDate"] = 7] = "EndDate";
    GuardType[GuardType["AllowList"] = 8] = "AllowList";
    GuardType[GuardType["MintLimit"] = 9] = "MintLimit";
    GuardType[GuardType["NftPayment"] = 10] = "NftPayment";
    GuardType[GuardType["RedeemedAmount"] = 11] = "RedeemedAmount";
    GuardType[GuardType["AddressGate"] = 12] = "AddressGate";
    GuardType[GuardType["NftGate"] = 13] = "NftGate";
    GuardType[GuardType["NftBurn"] = 14] = "NftBurn";
    GuardType[GuardType["TokenBurn"] = 15] = "TokenBurn";
    GuardType[GuardType["FreezeSolPayment"] = 16] = "FreezeSolPayment";
    GuardType[GuardType["FreezeTokenPayment"] = 17] = "FreezeTokenPayment";
    GuardType[GuardType["ProgramGate"] = 18] = "ProgramGate";
})(GuardType = exports.GuardType || (exports.GuardType = {}));
exports.guardTypeBeet = beet.fixedScalarEnum(GuardType);
//# sourceMappingURL=GuardType.js.map